// CAROUSEL
export const SET_CAROUSEL_INDEX = "SET_CAROUSEL_INDEX";
export const CAROUSEL_LOADING = "CAROUSEL_LOADING";
export const SET_INDEX_LABEL = "SET_INDEX_LABEL";
export const SET_SLIDE_MAX = "SET_SLIDE_MAX";
export const IS_FROM_INPUT = "IS_FROM_INPUT";
export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export const SET_ZOOM_LEVEL = "SET_ZOOM_LEVEL";
export const SET_REF_ZOOM = "SET_REF_ZOOM";
export const SET_BUTTON_DISABLED = "SET_BUTTON_DISABLED";
export const IS_MODAL_OPEN = "IS_MODAL_OPEN";
export const IS_RIGHT_SIDEBAR_OPEN = "IS_RIGHT_SIDEBAR_OPEN";
//COOKIE
export const SET_COOKIE_INFO = "SET_COOKIE_INFO";

//FLOATING MENU
export const IS_MENU_OPEN = "IS_MENU_OPEN";

//MODAL
export const OPEN_INTERACTIVITY_MODAL_STATIC =
  "OPEN_INTERACTIVITY_MODAL_STATIC";
export const OPEN_INTERACTIVITY_MODAL_DYNAMIC =
  "OPEN_INTERACTIVITY_MODAL_DYNAMIC";
export const CLOSE_INTERACTIVITY_MODAL = "CLOSE_INTERACTIVITY_MODAL";
export const START_LOADING_MODAL = "START_LOADING_MODAL";
export const END_LOADING_MODAL = "END_LOADING_MODAL";
export const OPEN_RELATED = "OPEN_RELATED";
export const SET_ERROR_MODAL = "SET_ERROR_MODAL";
export const ERROR_MODAL = "ERROR_MODAL";

// // const persona1 = new Person()
// Person.name

// PRODUCT
export const GET_PRICES = "GET_PRICES";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const SET_ERROR = "SET_ERROR";

//CART REDUCER
export const START_CART_LOADING = "START_CART_LOADING";
export const END_CART_LOADING = "END_CART_LOADING";
export const CLEAR_CART = "CLEAR_CART";
export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const UPDATE_QUANTITY_ITEM = "UPDATE_QUANTITY_ITEM";
export const LOADING_SPECIFIC_ITEM = "LOADING_SPECIFIC_ITEM";
export const SET_CART = "SET_CART";
export const ERROR_CART = "ERROR_CART";
export const OPEN_CART = "OPEN_CART";
export const CLOSE_CART = "CLOSE_CART";
export const CHECK_CART = "CHECK_CART";
export const EXPORT_CART_START_LOADING = "EXPORT_CART_START_LOADING";
export const EXPORT_CART_END_LOADING = "EXPORT_CART_END_LOADING";
export const MODAL_CART_ERROR = "MODAL_CART_ERROR";
export const RESET_MODAL_ERROR = "RESET_MODAL_ERROR";
export const RESET_MODAL_CLEAR_CART = "RESET_MODAL_CLEAR_CART";
export const MODAL_CLEAR_CART = "MODAL_CLEAR_CART";

//ERROR
export const MODAL_ERROR = "MODAL_ERROR";
export const RESET_ERRORS = "RESET_ERRORS";
export const SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR";
